import logo from './logo.svg';
import './App.css';

import React, { useState, useEffect } from 'react';

const App = () => {
  const today = new Date();
  const [currentDay, setCurrentDay] = useState(today.getDate());
  const [selectedMenuType, setSelectedMenuType] = useState(() => {
    // Retrieve the selected menu type from local storage if available
    const storedMenuType = localStorage.getItem('selectedMenuType');
    return storedMenuType ? storedMenuType : "special"; // Default to special menu if not stored
  });
  const [menus, setMenus] = useState({}); // Object to hold all menus

  const currDate = today.getDate();
  const currHour =today.getHours();
  const currMin =today.getMinutes();

  useEffect(() => {
    const storedMenus = localStorage.getItem('menus');
    const storedDate = localStorage.getItem('storedDate');
    if (storedMenus && storedDate === currDate) {
      // If menus are found in local storage, parse and set them
      setMenus(JSON.parse(storedMenus)[selectedMenuType]);
    }
    else {
      const fetchedMenus = {
        veg: {
          1: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney",
            lunch: "Chapathi, Veg Dahi Vala, Bisibela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet : Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Seasonal Fruit"
          },
          2: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Corn Flakes",
            lunch: "Roti, Dhal Makani, White Rice, Moore kulambu, Rasam, Cup Curd, Raw Banana Fry , Papad",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Veg : Gobi Manchurian, Seasonal Fruit"
          },
          3: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal, White Rice, Avarakkai sambar, Rasam, Cup Curd, Green Gram Sprouts, Fryums",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Mix Veg Poriyal, Curd rice, Musk melon"
          },
          4: {
            breakfast: "Gobi Paratha , Curd, Pickle, Kitchadi, Coconut Chutney",
            lunch: "Phulka, Mixed Dhal, Pudina Rice, White Rice, Manathakkali Vathal Kuzhambu, Rasam, Bitter gourd fry, Appalam, Cup Curd, Sweet : Carrot halwa",
            snacks: "Kachori, Tamarind Chutney",
            dinner: "Chapathi, Yellow Dhal, White Rice, Rasam, Loose Curd, Veg : Chilli Paneer, Banana"
          },
          5: {
            breakfast: "Masala Dosai, Sambar, Chutney",
            lunch: "Chapathi, Green gram Dhal, Coconut rice, White Rice, Keerai Sambar, Rasam, Cup Curd, Bhindi fry, Fryums",
            snacks: "French Fries",
            dinner: "Methi Chapathi, Channa masala, White Rice, Sambar, Rasam, Loose Curd, Aloo jeera poriyal, Fruit salad, Ice cream"
          },
          6: {
            breakfast: "Poori, Potato masala, Brown , Chocos",
            lunch: "Phulka, Dhal, White Rice, Rasam, Salna, Appalam, Cucumber Raitha, Veg : Chettinad Veg Biriyani, Gobi 65, Sweet : Payasam",
            snacks: "Sweet Corn Chat ",
            dinner: "Chapathi, Dhal Punjabi, White Rice, Sambar, Rasam, Loose Curd, Capsicum peas pulao, Mixed Veg Gravy, Papaya"
          },
          7: {
            breakfast: "Set Dosai, Vadacury, Chutney, Pasta",
            lunch: "Chapathi, Toor Dhal, Lemon Rice, White Rice, Knol Khol Sambar, Rasam, Appalam, Butter milk, Veg : Kadai mushroom",
            snacks: "Veg. Sandwich",
            dinner: "Chole Bhatura, Curd rice, White Rice, Sambar, Rasam, Bottle Guard Sabji, Seasonal Fruit"
          },
          8: {
            breakfast: "Paav Bhaji, Fry Chilly, Idly, Sambar, Chutney",
            lunch: "Chapati, Palak green gram dal, White Rice, Sundakai Vatha kuzlambu, Rasam, Potato fry, Appalam, Cup Curd, Sweet : Jangari",
            snacks: "Suzhiyam",
            dinner: "Wheat Roti, Dhal, Schezwan fried rice, White Rice, Sambar, Rasam, Butter Milk, Veg : Baby corn gravy, Water Melon"
          },
          9: {
            breakfast: "Poha Namkeen, Pongal, Sambar, Chutney",
            lunch: "Phulka, Dhal, Sepan Kizhangu fry, Papad, White Rice, Radish Sambar, Rasam, Cup Curd, Veg : Palak Paneer",
            snacks: "Chana Sundal",
            dinner: "Phulka, Dhal, Uthappam, Kerala kadala curry, White Rice, Sambar, Rasam, Knol Khol Poriyal, Loose Curd, Mix Veg Soup, Banana"
          },
          10: {
            breakfast: "Idly, Sambar, Chutney, Vadai",
            lunch: "Chapati, Dhal Makhani, Veg Pulav, White Rice, Karamani Kara Kulambu, Rasam, Cup Curd, Keerai Kuttu, Fryums",
            snacks: "Onion Pakoda",
            dinner: "Roti, Dhal, Yam fry, Garlic Sauce, White Rice, Sambar, Rasam, Loose Curd, Veg: Veg Chow Mein, Seasonal Fruit"
          },
          11: {
            breakfast: "Mixed Veg Paratha, Curd, Rava kitchadi, Chutney",
            lunch: "Phulka, Dhal, Tamarind Rice, White Rice, Bottlegourd Sambar, Rasam, Cup Curd, Avaraikai Poriyal, Papad, Sweet : Laddu",
            snacks: "Dahi Papdi Chaat",
            dinner: "Chapathi, Dhal, Urapadai, Chutney, White rice, Sambar, Rasam, Butter Milk, Veg : Tandoori Paneer Tikka, Banana"
          },
          12: {
            breakfast: "Podi Dosai, Sambar, Red chilli Chutney",
            lunch: "Chapathi, Masoor Dhal, Veg Kofta Gravy, White Rice, Paruppu Urundai Kulambai, Rasam, Cup Curd, Snakegourd Sabji, Appalam",
            snacks: "Veg Puff",
            dinner: "Wheat Parata, Veg Salna, White Rice, Sambar, Rasam, Loose Curd, Beans Carrot Poriyal, Fruit Salad"
          },
          13: {
            breakfast: "Methi poori, Channa Masala Brown Bread",
            lunch: "Phulka, Dhal Fry White Rice, Brinjal Gravy, RasamFryums, Onion Raitha Veg : Vegetable Dum Biriyani ,Gobi 65 Sweet : Kheer",
            snacks: "Aloo Samosa",
            dinner: "Chapathi, Dhal, Idli, Sambar White Rice, Rasam,Loose Curd Peerkangai Poriyal Banana"
          },
          14: {
            breakfast: "Mooli Paratha, Curd Varmicilli upma, Coconut Chutney",
            lunch: "Phulka, Urad Dhal White Rice, Chow chow Sambar,Rasam Cabbage Poriyal, Cup Curd, Papad Veg :Paneer Butter Masala",
            snacks: "Raw banana bajji Chutney",
            dinner: "Roti, Rajma masala, Ghee Rice, Dhal White Rice, Rasam, Butter Milk Aloo jeera poriyal Water Melon"
          },
          15: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney",
            lunch: "Chapathi, Veg Dahi Vala, Bisibela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet : Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Seasonal Fruit"
          },
          16: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Corn Flakes",
            lunch: "Roti, Dhal Makani, White Rice, Moore kulambu, Rasam, Cup Curd, Raw Banana Fry , Papad",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Veg : Gobi Manchurian, Seasonal Fruit"
          },
          17: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal, White Rice, Avarakkai sambar, Rasam, Cup Curd, Green Gram Sprouts, Fryums",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Mix Veg Poriyal, Curd rice, Musk melon"
          },
          18: {
            breakfast: "Gobi Paratha , Curd, Pickle, Kitchadi, Coconut Chutney",
            lunch: "Phulka, Mixed Dhal, Pudina Rice, White Rice, Manathakkali Vathal Kuzhambu, Rasam, Bitter gourd fry, Appalam, Cup Curd, Sweet : Carrot halwa",
            snacks: "Kachori, Tamarind Chutney",
            dinner: "Chapathi, Yellow Dhal, White Rice, Rasam, Loose Curd, Veg : Chilli Paneer, Banana"
          },
          19: {
            breakfast: "Masala Dosai, Sambar, Chutney",
            lunch: "Chapathi, Green gram Dhal, Coconut rice, White Rice, Keerai Sambar, Rasam, Cup Curd, Bhindi fry, Fryums",
            snacks: "French Fries",
            dinner: "Methi Chapathi, Channa masala, White Rice, Sambar, Rasam, Loose Curd, Aloo jeera poriyal, Fruit salad, Ice cream"
          },
          20: {
            breakfast: "Poori, Potato masala, Brown , Chocos",
            lunch: "Phulka, Dhal, White Rice, Rasam, Salna, Appalam, Cucumber Raitha, Veg : Chettinad Veg Biriyani, Gobi 65, Sweet : Payasam",
            snacks: "Sweet Corn Chat ",
            dinner: "Chapathi, Dhal Punjabi, White Rice, Sambar, Rasam, Loose Curd, Capsicum peas pulao, Mixed Veg Gravy, Papaya"
          },
          21: {
            breakfast: "Set Dosai, Vadacury, Chutney, Pasta",
            lunch: "Chapathi, Toor Dhal, Lemon Rice, White Rice, Knol Khol Sambar, Rasam, Appalam, Butter milk, Veg : Kadai mushroom",
            snacks: "Veg. Sandwich",
            dinner: "Chole Bhatura, Curd rice, White Rice, Sambar, Rasam, Bottle Guard Sabji, Seasonal Fruit"
          },
          22: {
            breakfast: "Paav Bhaji, Fry Chilly, Idly, Sambar, Chutney",
            lunch: "Chapati, Palak green gram dal, White Rice, Sundakai Vatha kuzlambu, Rasam, Potato fry, Appalam, Cup Curd, Sweet : Jangari",
            snacks: "Suzhiyam",
            dinner: "Wheat Roti, Dhal, Schezwan fried rice, White Rice, Sambar, Rasam, Butter Milk, Veg : Baby corn gravy, Water Melon"
          },
          23: {
            breakfast: "Poha Namkeen, Pongal, Sambar, Chutney",
            lunch: "Phulka, Dhal, Sepan Kizhangu fry, Papad, White Rice, Radish Sambar, Rasam, Cup Curd, Veg : Palak Paneer",
            snacks: "Chana Sundal",
            dinner: "Phulka, Dhal, Uthappam, Kerala kadala curry, White Rice, Sambar, Rasam, Knol Khol Poriyal, Loose Curd, Mix Veg Soup, Banana"
          },
          24: {
            breakfast: "Idly, Sambar, Chutney, Vadai",
            lunch: "Chapati, Dhal Makhani, Veg Pulav, White Rice, Karamani Kara Kulambu, Rasam, Cup Curd, Keerai Kuttu, Fryums",
            snacks: "Onion Pakoda",
            dinner: "Roti, Dhal, Yam fry, Garlic Sauce, White Rice, Sambar, Rasam, Loose Curd, Veg: Veg Chow Mein, Seasonal Fruit"
          },
          25: {
            breakfast: "Mixed Veg Paratha, Curd, Rava kitchadi, Chutney",
            lunch: "Phulka, Dhal, Tamarind Rice, White Rice, Bottlegourd Sambar, Rasam, Cup Curd, Avaraikai Poriyal, Papad, Sweet : Laddu",
            snacks: "Dahi Papdi Chaat",
            dinner: "Chapathi, Dhal, Urapadai, Chutney, White rice, Sambar, Rasam, Butter Milk, Veg : Tandoori Paneer Tikka, Banana"
          },
          26: {
            breakfast: "Podi Dosai, Sambar, Red chilli Chutney",
            lunch: "Chapathi, Masoor Dhal, Veg Kofta Gravy, White Rice, Paruppu Urundai Kulambai, Rasam, Cup Curd, Snakegourd Sabji, Appalam",
            snacks: "Veg Puff",
            dinner: "Wheat Parata, Veg Salna, White Rice, Sambar, Rasam, Loose Curd, Beans Carrot Poriyal, Fruit Salad"
          },
          27: {
            breakfast: "Methi poori, Channa Masala Brown Bread",
            lunch: "Phulka, Dhal Fry White Rice, Brinjal Gravy, RasamFryums, Onion Raitha Veg : Vegetable Dum Biriyani ,Gobi 65 Sweet : Kheer",
            snacks: "Aloo Samosa",
            dinner: "Chapathi, Dhal, Idli, Sambar White Rice, Rasam,Loose Curd Peerkangai Poriyal Banana"
          },
          28: {
            breakfast: "Mooli Paratha, Curd Varmicilli upma, Coconut Chutney",
            lunch: "Phulka, Urad Dhal White Rice, Chow chow Sambar,Rasam Cabbage Poriyal, Cup Curd, Papad Veg :Paneer Butter Masala",
            snacks: "Raw banana bajji Chutney",
            dinner: "Roti, Rajma masala, Ghee Rice, Dhal White Rice, Rasam, Butter Milk Aloo jeera poriyal Water Melon"
          },
          29: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney",
            lunch: "Chapathi, Veg Dahi Vala, Bisibela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet : Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Seasonal Fruit"
          },
          30: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Corn Flakes",
            lunch: "Roti, Dhal Makani, White Rice, Moore kulambu, Rasam, Cup Curd, Raw Banana Fry , Papad",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Veg : Gobi Manchurian, Seasonal Fruit"
          },
          31: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal, White Rice, Avarakkai sambar, Rasam, Cup Curd, Green Gram Sprouts, Fryums",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Mix Veg Poriyal, Curd rice, Musk melon"
          },

        },
        special:{
          

          1: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney, Veg: Mixed Sprouts Sundal, Non Veg: Scrambled Egg, Mint Lemon, Chocos",
            lunch: "Chapathi, Veg Dahi Vala, Bisbela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet: Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Clustered Beans poriyal, Spring onion Soup, Seasonal Fruit"
          },
          2: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Veg: Boiled Sweet Corn, Non Veg: Boiled Egg, Mixed Fruit Juice",
            lunch: "Roti, Dhal Makani, White Rice, White pumpkin Moore kulambu, Rasam, Cup Curd , Raw Banana Fry, Papad Sweet : Kova Mysorepaku",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Veg: Gobi Manchurian, Non Veg: Chicken Manchurian, Veg Chettinadu Soup, Seasonal Fruit"
          },
          3: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney, Veg: Masala Black Chenna, Non Veg: Scrambled Egg, Amla mint juice, Chocos",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal White Rice, Avarakkai sambar, Rasam, Cup Curd Green Gram Sprouts, Fryums Sweet : Rasgulla",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Mix Veg Poriyal, Curd rice, Chow Mein Soup, Musk melon"
          },
          4: {
            breakfast: "Gobi Paratha, Curd, Pickle, Kitchadi, Coconut Chutney, Veg: Vegetable Salad, Non Veg: Boiled Egg Masala, Grape Juice",
            lunch: "Phulka, Mixed Dhal, Pudina Rice White Rice, Manathakkali Vathal Kuzhambu, Rasam Bitter Gourd fry  , Cup Curd, Appalam Sweet : Carrot halwa",
            snacks: "Kachori, Tamarind Chutney",
            dinner: "Chapathi, Yellow Dhal, White Rice, Rasam, Loose Curd, Veg: Chilli Paneer, Non Veg: Chilli Chicken, Mixed Veg Soup, Banana"
          },
          5: {
            breakfast: "Masala Dosai, Sambar, Chutney, Veg: Cowpea (Karamani) Sundal, Non Veg: Boiled Egg, Papaya Juice",
            lunch: "Chapathi, Green gram Dhal, Coconut rice White Rice, Keerai Sambar, Rasam, Cup Curd Bhindi fry, Fryums Sweet : Dry Jamoon",
            snacks: "French fries",
            dinner: "Methi Chapathi, Channa masala, White Rice, Sambar, Rasam, Loose Curd, Aloo jeera poriyal, Mushroom Soup, Fruit salad, Ice cream"
          },
          6: {
            breakfast: "Poori, Potato masala, Brown Bread, Veg: Vegetable Salad, Non Veg: Masala Omelette, Water Melon Juice",
            lunch: "Phulka, Dhal,White Rice, Rasam, Salna Appalam, Cucumber Raitha Veg : Chettinad Veg Biriyani, Gobi 65 Non Veg : Chicken Biriyani Sweet : Payasam",
            snacks: "Sweet corn chat ",
            dinner: "Chapathi, Dhal Punjabi, White Rice, Sambar, Rasam, Loose Curd, Capsicum Peas Pulao, Mixed Veg Gravy, Veg Clear Soup, Papaya"
          },
          7: {
            breakfast: "Set Dosai, Vadacury, Chutney, Pasta, Veg: Multi Grain Sundal, Non Veg: Boiled Egg, Pineapple Juice ",
            lunch: "Chapathi, Toor Dhal, Lemon Rice, White Rice, Knol Khol Sambar, Rasam, Butter milk, Appalam, Veg: Kadai mushroom, Non Veg: Kadai chicken, Sweet: Rava Laddu",
            snacks: "Veg. Sandwich",
            dinner: "Chole Bhatura, Curd rice, White Rice, Sambar, Rasam, Bottle Guard Sabji, Veg Noodle Soup, Seasonal Fruit"
          },
          8: {
            breakfast: "Paav Bhaji, Fry Chilly, Idly, Sambar, Chutney, Veg: Sauthe Black Chenna Sundal, Non Veg: Scrambled Egg, Dates Milkshake, Chocos",
            lunch: "Chapati, Palak green gram dal, White Rice, Drumstick brinjal kara kazulambu, Rasam, Potato fry, Appalam, Cup Curd, Sweet: Jangari",
            snacks: "Suzhiyam",
            dinner: "Wheat Roti, Dhal, Schezwan fried rice, White Rice, Sambar, Rasam, Butter Milk, Veg: Baby corn gravy, Non Veg: Chicken gravy, Hot and Sour Soup, Water Melon"
          },
          9: {
            breakfast: "Poha Namkeen, Pongal, Sambar, Chutney, Veg: Veg Salad, Non Veg: French Toast, Mango Juice",
            lunch: "Phulka, Dhal, Sepan Kizhangu fry, Papad, White Rice, Radish Sambar, Rasam, Cup Curd, Veg: Palak Paneer- 03.07.2024/ Paneer Fry- 31.07.2024, Non Veg: Fish Curry- 03.07.2024 / Fish Fry- 31.07.2024, Sweet: Badusha",
            snacks: "Chana Sundal",
            dinner: "Phulka, Dhal, Uthappam, Kerala kadala curry, White Rice, Sambar, Rasam, Knol Khol Poriyal, Loose Curd, Mix Veg Soup, Banana"
          },
          10: {
            breakfast: "Idly, Sambar, Chutney, Vadai, Veg: Sprouted Moong Dhal, Non Veg: Masala Omlette, Water Melon Juice, Chocos",
            lunch: "Chapati, Dhal Makhani, Veg Pulav, White Rice, Karamani Kara Kulambu, Rasam, Cup Curd, Keerai Kuttu, Fryums, Sweet: Milk Peda",
            snacks: "Onion Pakoda",
            dinner: "Roti, Dhal, Yam fry, Garlic Sauce, White Rice, Sambar, Rasam, Loose Curd, Veg: Veg Chow Mein, Non Veg: Egg Chow Mein, Cream Of Veg Soup, Seasoanl Fruit"
          },
          11: {
            breakfast: "Mixed Veg Paratha, Curd, Rava kitchadi, Chutney, Veg: Peanut Sundal, Non Veg: French toast, Sapota Juice",
            lunch: "Phulka, Dhal, Tamarind Rice, White Rice, Bottlegourd Sambar, Rasam, Cup Curd, Avaraikai poriyal, Papad, Sweet: Laddu",
            snacks: "Dahi Papdi Chat",
            dinner: "Chapathi, Dhal, Urapadai, Chutney, White rice, Sambar, Rasam, Butter Milk, Veg: Tandoori Paneer Tikka, Non Veg: Tandoori Chicken, Palak Soup, Banana"
          },
          12: {
            breakfast: "Podi Dosai, Sambar, Red chilli Chutney, Veg: Moochai Payaru Sundal, Non Veg: Boiled Egg Masala, Mixed Fruit Juice, Chocos",
            lunch: "Chapathi, Masoor Dhal, Veg Kofta Gravy, White Rice, Urundai Kulambu, Rasam, Cup Curd, Snakegourd Sabzi, Appalam, Sweet: Shahi Tukra",
            snacks: "Veg Puff",
            dinner: "Wheat Parata, Veg Salana, White Rice, Sambar, Rasam, Loose Curd, Beans Carrot Poriyal, Veg Manchow Soup, Fruit Salad"
          },
          13: {
            breakfast: "Methi poori, Channa Masala, Brown Bread, Veg: Green Gram Sprouts, Non Veg: Omlette, Apple Juice",
            lunch: "Phulka, Dhal Fry, White Rice, Brinjal Gravy, Rasam, Fryums, Onion Raitha, Veg: Vegetable Dum Biriyani, Gobi 65, Non Veg: Chicken Dum Biriyani, Sweet: Kheer",
            snacks: "Aloo Samosa",
            dinner: "Chapathi, Dhal, Idli, Sambar, White Rice, Rasam, Loose Curd, Peerkangai Poriyal, Carrot Ginger Soup, Banana"
          },
          14: {
            breakfast: "Mooli Paratha, Curd, Varmicilli upma, Coconut Chutney, Veg: Vegetable Salad, Non Veg: Boiled Egg, Musk Melon Juice",
            lunch: "Phulka, Urad Dhal, Papad, White Rice, Chow chow Sambar, Rasam, Cup Curd, Veg: Paneer Butter Masala, Non Veg: Chicken Butter Masala, Sweet: Jilebi",
            snacks: "Raw Banana Bhaji",
            dinner: "Roti, Rajma masala, Ghee Rice, Dhal, White Rice, Rasam, Butter Milk, Aloo Jeera Poriyal, Sweet Corn Soup, Water Melon"
          },

          15: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney, Veg: Mixed Sprouts Sundal, Non Veg: Scrambled Egg, Mint Lemon, Chocos",
            lunch: "Chapathi, Veg Dahi Vala, Bisbela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet: Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Clustered Beans poriyal, Spring onion Soup, Seasonal Fruit"
          },
          16: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Veg: Boiled Sweet Corn, Non Veg: Boiled Egg, Mixed Fruit Juice",
            lunch: "Roti, Dhal Makani, White Rice, White pumpkin Moore kulambu, Rasam, Cup Curd , Raw Banana Fry, Papad Sweet : Kova Mysorepaku",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Veg: Gobi Manchurian, Non Veg: Chicken Manchurian, Veg Chettinadu Soup, Seasonal Fruit"
          },
          17: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney, Veg: Masala Black Chenna, Non Veg: Scrambled Egg, Amla mint juice, Chocos",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal White Rice, Avarakkai sambar, Rasam, Cup Curd Green Gram Sprouts, Fryums Sweet : Rasgulla",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Mix Veg Poriyal, Curd rice, Chow Mein Soup, Musk melon"
          },
          18: {
            breakfast: "Gobi Paratha, Curd, Pickle, Kitchadi, Coconut Chutney, Veg: Vegetable Salad, Non Veg: Boiled Egg Masala, Grape Juice",
            lunch: "Phulka, Mixed Dhal, Pudina Rice White Rice, Manathakkali Vathal Kuzhambu, Rasam Bitter Gourd fry  , Cup Curd, Appalam Sweet : Carrot halwa",
            snacks: "Kachori, Tamarind Chutney",
            dinner: "Chapathi, Yellow Dhal, White Rice, Rasam, Loose Curd, Veg: Chilli Paneer, Non Veg: Chilli Chicken, Mixed Veg Soup, Banana"
          },
          19: {
            breakfast: "Masala Dosai, Sambar, Chutney, Veg: Cowpea (Karamani) Sundal, Non Veg: Boiled Egg, Papaya Juice",
            lunch: "Chapathi, Green gram Dhal, Coconut rice White Rice, Keerai Sambar, Rasam, Cup Curd Bhindi fry, Fryums Sweet : Dry Jamoon",
            snacks: "French fries",
            dinner: "Methi Chapathi, Channa masala, White Rice, Sambar, Rasam, Loose Curd, Aloo jeera poriyal, Mushroom Soup, Fruit salad, Ice cream"
          },
          20: {
            breakfast: "Poori, Potato masala, Brown Bread, Veg: Vegetable Salad, Non Veg: Masala Omelette, Water Melon Juice",
            lunch: "Phulka, Dhal,White Rice, Rasam, Salna Appalam, Cucumber Raitha Veg : Chettinad Veg Biriyani, Gobi 65 Non Veg : Chicken Biriyani Sweet : Payasam",
            snacks: "Sweet corn chat ",
            dinner: "Chapathi, Dhal Punjabi, White Rice, Sambar, Rasam, Loose Curd, Capsicum Peas Pulao, Mixed Veg Gravy, Veg Clear Soup, Papaya"
          },
          21: {
            breakfast: "Set Dosai, Vadacury, Chutney, Pasta, Veg: Multi Grain Sundal, Non Veg: Boiled Egg, Pineapple Juice ",
            lunch: "Chapathi, Toor Dhal, Lemon Rice, White Rice, Knol Khol Sambar, Rasam, Butter milk, Appalam, Veg: Kadai mushroom, Non Veg: Kadai chicken, Sweet: Rava Laddu",
            snacks: "Veg. Sandwich",
            dinner: "Chole Bhatura, Curd rice, White Rice, Sambar, Rasam, Bottle Guard Sabji, Veg Noodle Soup, Seasonal Fruit"
          },
          22: {
            breakfast: "Paav Bhaji, Fry Chilly, Idly, Sambar, Chutney, Veg: Sauthe Black Chenna Sundal, Non Veg: Scrambled Egg, Dates Milkshake, Chocos",
            lunch: "Chapati, Palak green gram dal, White Rice, Drumstick brinjal kara kazulambu, Rasam, Potato fry, Appalam, Cup Curd, Sweet: Jangari",
            snacks: "Suzhiyam",
            dinner: "Wheat Roti, Dhal, Schezwan fried rice, White Rice, Sambar, Rasam, Butter Milk, Veg: Baby corn gravy, Non Veg: Chicken gravy, Hot and Sour Soup, Water Melon"
          },
          23: {
            breakfast: "Poha Namkeen, Pongal, Sambar, Chutney, Veg: Veg Salad, Non Veg: French Toast, Mango Juice",
            lunch: "Phulka, Dhal, Sepan Kizhangu fry, Papad, White Rice, Radish Sambar, Rasam, Cup Curd, Veg: Palak Paneer- 03.07.2024/ Paneer Fry- 31.07.2024, Non Veg: Fish Curry- 03.07.2024 / Fish Fry- 31.07.2024, Sweet: Badusha",
            snacks: "Chana Sundal",
            dinner: "Phulka, Dhal, Uthappam, Kerala kadala curry, White Rice, Sambar, Rasam, Knol Khol Poriyal, Loose Curd, Mix Veg Soup, Banana"
          },
          24: {
            breakfast: "Idly, Sambar, Chutney, Vadai, Veg: Sprouted Moong Dhal, Non Veg: Masala Omlette, Water Melon Juice, Chocos",
            lunch: "Chapati, Dhal Makhani, Veg Pulav, White Rice, Karamani Kara Kulambu, Rasam, Cup Curd, Keerai Kuttu, Fryums, Sweet: Milk Peda",
            snacks: "Onion Pakoda",
            dinner: "Roti, Dhal, Yam fry, Garlic Sauce, White Rice, Sambar, Rasam, Loose Curd, Veg: Veg Chow Mein, Non Veg: Egg Chow Mein, Cream Of Veg Soup, Seasoanl Fruit"
          },
          25: {
            breakfast: "Mixed Veg Paratha, Curd, Rava kitchadi, Chutney, Veg: Peanut Sundal, Non Veg: French toast, Sapota Juice",
            lunch: "Phulka, Dhal, Tamarind Rice, White Rice, Bottlegourd Sambar, Rasam, Cup Curd, Avaraikai poriyal, Papad, Sweet: Laddu",
            snacks: "Dahi Papdi Chat",
            dinner: "Chapathi, Dhal, Urapadai, Chutney, White rice, Sambar, Rasam, Butter Milk, Veg: Tandoori Paneer Tikka, Non Veg: Tandoori Chicken, Palak Soup, Banana"
          },
          26: {
            breakfast: "Podi Dosai, Sambar, Red chilli Chutney, Veg: Moochai Payaru Sundal, Non Veg: Boiled Egg Masala, Mixed Fruit Juice, Chocos",
            lunch: "Chapathi, Masoor Dhal, Veg Kofta Gravy, White Rice, Urundai Kulambu, Rasam, Cup Curd, Snakegourd Sabzi, Appalam, Sweet: Shahi Tukra",
            snacks: "Veg Puff",
            dinner: "Wheat Parata, Veg Salana, White Rice, Sambar, Rasam, Loose Curd, Beans Carrot Poriyal, Veg Manchow Soup, Fruit Salad"
          },
          27: {
            breakfast: "Methi poori, Channa Masala, Brown Bread, Veg: Green Gram Sprouts, Non Veg: Omlette, Apple Juice",
            lunch: "Phulka, Dhal Fry, White Rice, Brinjal Gravy, Rasam, Fryums, Onion Raitha, Veg: Vegetable Dum Biriyani, Gobi 65, Non Veg: Chicken Dum Biriyani, Sweet: Kheer",
            snacks: "Aloo Samosa",
            dinner: "Chapathi, Dhal, Idli, Sambar, White Rice, Rasam, Loose Curd, Peerkangai Poriyal, Carrot Ginger Soup, Banana"
          },
          28: {
            breakfast: "Mooli Paratha, Curd, Varmicilli upma, Coconut Chutney, Veg: Vegetable Salad, Non Veg: Boiled Egg, Musk Melon Juice",
            lunch: "Phulka, Urad Dhal, Papad, White Rice, Chow chow Sambar, Rasam, Cup Curd, Veg: Paneer Butter Masala, Non Veg: Chicken Butter Masala, Sweet: Jilebi",
            snacks: "Raw Banana Bhaji",
            dinner: "Roti, Rajma masala, Ghee Rice, Dhal, White Rice, Rasam, Butter Milk, Aloo Jeera Poriyal, Sweet Corn Soup, Water Melon"
          },
          29: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney, Veg: Mixed Sprouts Sundal, Non Veg: Scrambled Egg, Mint Lemon, Chocos",
            lunch: "Chapathi, Veg Dahi Vala, Bisbela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet: Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Clustered Beans poriyal, Spring onion Soup, Seasonal Fruit"
          },
          30: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Veg: Boiled Sweet Corn, Non Veg: Boiled Egg, Mixed Fruit Juice",
            lunch: "Roti, Dhal Makani, White Rice, White pumpkin Moore kulambu, Rasam, Cup Curd , Raw Banana Fry, Papad Sweet : Kova Mysorepaku",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Veg: Gobi Manchurian, Non Veg: Chicken Manchurian, Veg Chettinadu Soup, Seasonal Fruit"
          },
          31: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney, Veg: Masala Black Chenna, Non Veg: Scrambled Egg, Amla mint juice, Chocos",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal White Rice, Avarakkai sambar, Rasam, Cup Curd Green Gram Sprouts, Fryums Sweet : Rasgulla",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Mix Veg Poriyal, Curd rice, Chow Mein Soup, Musk melon"
          },

          
        },
        nonVeg: {
          
          1: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney Non Veg : Scrambled Egg",
            lunch: "Chapathi, Veg Dahi Vala, Bisibela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet : Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Clustered beans poriyal, Seasonal Fruit"
          },
          2: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Corn Flakes, Non Veg : Boiled Egg",
            lunch: "Roti, Dhal Makani, White Rice, White Pumpkin Moore kulambu, Rasam, Cup Curd, Raw Banana Fry, Papad",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Non Veg : Chicken Manchurian, Seasonal Fruit"
          },
          3: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney Non Veg : Scrambled Egg",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal, White Rice, Avarakkai sambar, Rasam, Cup Curd, Green Gram Sprouts, Fryums",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Chow Chow Kootu, Curd rice, Musk melon"
          },
          4: {
            breakfast: "Gobi Paratha, Curd, Pickle, Kitchadi, Coconut Chutney, Non Veg : Boiled Egg Masala",
            lunch: "Phulka, Mixed Dhal, Pudina Rice, White Rice, Manathakkali Vathal Kuzhambu, Rasam, Bitter gourd fry, Appalam, Cup Curd, Sweet : Carrot halwa",
            snacks: "Kachori Tamarid Chutney",
            dinner: "Chapathi, Yellow Dhal, White Rice, Rasam, Loose Curd, Non Veg : Chilli Chicken, Banana"
          },
          5: {
            breakfast: "Masala Dosai, Sambar, Chutney Non Veg : Boiled Egg",
            lunch: "Chapathi, Green gram Dhal, Coconut rice, White Rice, Keerai Sambar, Rasam, Cup Curd, Bhindi fry, Fryums",
            snacks: "French Fries",
            dinner: "Methi Chapathi, Channa masala, White Rice, Sambar, Rasam, Loose Curd, Kovaikai poriyal, Fruit salad, Ice cream"
          },
          6: {
            breakfast: "Poori, Potato masala, Brown Bread, Chocos, Non Veg : Masala Omelette",
            lunch: "Phulka, Dhal, White Rice, Rasam, Salna, Appalam, Cucumber Raitha, Non Veg : Chicken Biriyani, Sweet : Payasam",
            snacks: "Sweet Corn Chat",
            dinner: "Chapathi, Dhal Punjabi, White Rice, Sambar, Rasam, Loose Curd, Capsicum Peas Pulav, Mixed veg Gravy, Papaya"
          },
          7: {
            breakfast: "Set Dosai, Vadacury, Chutney Pasta Non Veg: Boiled Egg",
            lunch: "Chapathi, Toor Dhal, Lemon Rice, White Rice, Knol Khol Sambar, Rasam, Appalam, Butter milk, Non Veg: Kadai chicken",
            snacks: "Veg. Sandwich",
            dinner: "Chole Bhatura, Curd rice, White Rice, Sambar, Rasam, Bottle Guard Sabji, Seasonal Fruit"
          },
          8: {
            breakfast: "Paav Bhaji, Fry Chilly, Idly, Sambar, Chutney Non Veg : Scrambled Egg",
            lunch: "Chapati, Palak green gram dal, White Rice, Drumstick brinjal kara kazulambu, Rasam, Potato fry, Appalam, Cup Curd, Sweet : Jangari",
            snacks: "Suzhiyam",
            dinner: "Wheat Roti, Dhal, Schezwan fried rice, White Rice, Sambar, Rasam, Butter Milk, Non Veg : Chicken gravy, Water Melon"
          },
          9: {
            breakfast: "Poha Namkeen, Pongal, Sambar, Chutney Non Veg : French Toast",
            lunch: "Phulka, Dhal, Sepan Kizhangu fry, Papad, White Rice, Radish Sambar, Rasam, Cup Curd, Non-Veg : Fish Curry",
            snacks: "Chana Sundal",
            dinner: "Phulka, Dhal, Uthappam, Kerala kadala curry, White Rice, Sambar, Rasam, Knol Khol Poriyal, Loose Curd, Mix Veg Soup, Banana"
          },
          10: {
            breakfast: "Idly, Sambar, Chutney, Vadai Non Veg : Masala Omlette",
            lunch: "Chapati, Dhal Makhani, Veg Pulav, White Rice, Karamani Kara Kulambu, Rasam, Cup Curd, Keerai Kuttu, Fryums",
            snacks: "Onion Pakoda",
            dinner: "Roti, Dhal, Yam fry, Garlic Sauce, White Rice, Sambar, Rasam, Loose Curd, Non Veg : Egg Chow Mein, Seasonal Fruit"
          },
          11: {
            breakfast: "Mixed Veg Paratha, Curd, Rava kitchadi, Chutney Non Veg : French toast",
            lunch: "Phulka, Dhal, Tamarind Rice, White Rice, bottleguord Sambar, Rasam, Cup Curd, Avaraikai Poriyal, Papad, Sweet : Laddu",
            snacks: "Dahi Papdi Chaat",
            dinner: "Chapathi, Dhal, Urapadai, Chutney, White rice, Sambar, Rasam, Butter Milk, Non Veg : Tandoori Chicken, Banana"
          },
          12: {
            breakfast: "Podi Dosai, Sambar, Red chilli Chutney Non Veg : Boiled Egg Masala",
            lunch: "Chapathi, Masoor Dhal, Veg Kofta Gravy, White Rice, Paruppu Urudai Kulambu, Rasam, Cup Curd,Snakeguord Sabji, Appalam",
            snacks: "Veg Puff",
            dinner: "Wheat Parata, Veg Salana, White Rice, Sambar, Rasam, Loose Curd, Beans Carrot Poriyal, Fruit Salad"
          },

          13: {
            breakfast: "Methi poori, Channa Masala, Brown Bread Non Veg : Omlette",
            lunch: "Phulka, Dhal Fry, White Rice, Brinjal Gravy, Rasam, Fryums, Onion Raitha, Non Veg : Chicken Dum Biriyani, Sweet : Kheer",
            snacks: "Aloo Samosa",
            dinner: "Chapathi, Dhal, Idli, Sambar, White Rice, Rasam, Loose Curd, Peerkangai Poriyal, Banana"
          },
          14: {
            breakfast: "Mooli Paratha, Curd, Varmicilli upma, Coconut Chutney Non Veg : Boiled Egg",
            lunch: "Phulka, Urad Dhal, White Rice, Chow chow Sambar, Rasam, Cup Curd, Papad, Non Veg : Chicken Butter Masala",
            snacks: "Raw Banana Bhaji",
            dinner: "Roti, Rajma masala, Ghee Rice, Dhal, White Rice, Rasam, Butter Milk, Kovaikai Poriyal, Water Melon"
          },

          15: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney Non Veg : Scrambled Egg",
            lunch: "Chapathi, Veg Dahi Vala, Bisibela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet : Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Clustered beans poriyal, Seasonal Fruit"
          },
          16: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Corn Flakes, Non Veg : Boiled Egg",
            lunch: "Roti, Dhal Makani, White Rice, White Pumpkin Moore kulambu, Rasam, Cup Curd, Raw Banana Fry, Papad",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Non Veg : Chicken Manchurian, Seasonal Fruit"
          },
          17: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney Non Veg : Scrambled Egg",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal, White Rice, Avarakkai sambar, Rasam, Cup Curd, Green Gram Sprouts, Fryums",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Chow Chow Kootu, Curd rice, Musk melon"
          },
          18: {
            breakfast: "Gobi Paratha, Curd, Pickle, Kitchadi, Coconut Chutney, Non Veg : Boiled Egg Masala",
            lunch: "Phulka, Mixed Dhal, Pudina Rice, White Rice, Manathakkali Vathal Kuzhambu, Rasam, Bitter gourd fry, Appalam, Cup Curd, Sweet : Carrot halwa",
            snacks: "Kachori Tamarid Chutney",
            dinner: "Chapathi, Yellow Dhal, White Rice, Rasam, Loose Curd, Non Veg : Chilli Chicken, Banana"
          },
          19: {
            breakfast: "Masala Dosai, Sambar, Chutney Non Veg : Boiled Egg",
            lunch: "Chapathi, Green gram Dhal, Coconut rice, White Rice, Keerai Sambar, Rasam, Cup Curd, Bhindi fry, Fryums",
            snacks: "French Fries",
            dinner: "Methi Chapathi, Channa masala, White Rice, Sambar, Rasam, Loose Curd, Kovaikai poriyal, Fruit salad, Ice cream"
          },
          20: {
            breakfast: "Poori, Potato masala, Brown Bread, Chocos, Non Veg : Masala Omelette",
            lunch: "Phulka, Dhal, White Rice, Rasam, Salna, Appalam, Cucumber Raitha, Non Veg : Chicken Biriyani, Sweet : Payasam",
            snacks: "Sweet Corn Chat",
            dinner: "Chapathi, Dhal Punjabi, White Rice, Sambar, Rasam, Loose Curd, Capsicum Peas Pulav, Mixed veg Gravy, Papaya"
          },
          21: {
            breakfast: "Set Dosai, Vadacury, Chutney Pasta Non Veg: Boiled Egg",
            lunch: "Chapathi, Toor Dhal, Lemon Rice, White Rice, Knol Khol Sambar, Rasam, Appalam, Butter milk, Non Veg: Kadai chicken",
            snacks: "Veg. Sandwich",
            dinner: "Chole Bhatura, Curd rice, White Rice, Sambar, Rasam, Bottle Guard Sabji, Seasonal Fruit"
          },
          22: {
            breakfast: "Paav Bhaji, Fry Chilly, Idly, Sambar, Chutney Non Veg : Scrambled Egg",
            lunch: "Chapati, Palak green gram dal, White Rice, Drumstick brinjal kara kazulambu, Rasam, Potato fry, Appalam, Cup Curd, Sweet : Jangari",
            snacks: "Suzhiyam",
            dinner: "Wheat Roti, Dhal, Schezwan fried rice, White Rice, Sambar, Rasam, Butter Milk, Non Veg : Chicken gravy, Water Melon"
          },
          23: {
            breakfast: "Poha Namkeen, Pongal, Sambar, Chutney Non Veg : French Toast",
            lunch: "Phulka, Dhal, Sepan Kizhangu fry, Papad, White Rice, Radish Sambar, Rasam, Cup Curd, Non-Veg : Fish Curry",
            snacks: "Chana Sundal",
            dinner: "Phulka, Dhal, Uthappam, Kerala kadala curry, White Rice, Sambar, Rasam, Knol Khol Poriyal, Loose Curd, Mix Veg Soup, Banana"
          },
          24: {
            breakfast: "Idly, Sambar, Chutney, Vadai Non Veg : Masala Omlette",
            lunch: "Chapati, Dhal Makhani, Veg Pulav, White Rice, Karamani Kara Kulambu, Rasam, Cup Curd, Keerai Kuttu, Fryums",
            snacks: "Onion Pakoda",
            dinner: "Roti, Dhal, Yam fry, Garlic Sauce, White Rice, Sambar, Rasam, Loose Curd, Non Veg : Egg Chow Mein, Seasonal Fruit"
          },
          25: {
            breakfast: "Mixed Veg Paratha, Curd, Rava kitchadi, Chutney Non Veg : French toast",
            lunch: "Phulka, Dhal, Tamarind Rice, White Rice, bottleguord Sambar, Rasam, Cup Curd, Avaraikai Poriyal, Papad, Sweet : Laddu",
            snacks: "Dahi Papdi Chaat",
            dinner: "Chapathi, Dhal, Urapadai, Chutney, White rice, Sambar, Rasam, Butter Milk, Non Veg : Tandoori Chicken, Banana"
          },
          26: {
            breakfast: "Podi Dosai, Sambar, Red chilli Chutney Non Veg : Boiled Egg Masala",
            lunch: "Chapathi, Masoor Dhal, Veg Kofta Gravy, White Rice, Paruppu Urudai Kulambu, Rasam, Cup Curd,Snakeguord Sabji, Appalam",
            snacks: "Veg Puff",
            dinner: "Wheat Parata, Veg Salana, White Rice, Sambar, Rasam, Loose Curd, Beans Carrot Poriyal, Fruit Salad"
          },

          27: {
            breakfast: "Methi poori, Channa Masala, Brown Bread Non Veg : Omlette",
            lunch: "Phulka, Dhal Fry, White Rice, Brinjal Gravy, Rasam, Fryums, Onion Raitha, Non Veg : Chicken Dum Biriyani, Sweet : Kheer",
            snacks: "Aloo Samosa",
            dinner: "Chapathi, Dhal, Idli, Sambar, White Rice, Rasam, Loose Curd, Peerkangai Poriyal, Banana"
          },
          28: {
            breakfast: "Mooli Paratha, Curd, Varmicilli upma, Coconut Chutney Non Veg : Boiled Egg",
            lunch: "Phulka, Urad Dhal, White Rice, Chow chow Sambar, Rasam, Cup Curd, Papad, Non Veg : Chicken Butter Masala",
            snacks: "Raw Banana Bhaji",
            dinner: "Roti, Rajma masala, Ghee Rice, Dhal, White Rice, Rasam, Butter Milk, Kovaikai Poriyal, Water Melon"
          },
          29: {
            breakfast: "Vada Pav, Mint Chutney, Podi Idly, Sambar, Chutney Non Veg : Scrambled Egg",
            lunch: "Chapathi, Veg Dahi Vala, Bisibela Bath, White Rice, Rasam, Cup Curd, Potato Chips, Carrot Poriyal, Sweet : Gulab Jamun",
            snacks: "Masala Poori",
            dinner: "Phulka, Mix Dhal, Plain Dosai, Kara Chutney, White Rice, Sambar, Rasam, Loose Curd, Clustered beans poriyal, Seasonal Fruit"
          },
          30: {
            breakfast: "Pongal, Sambar, Chutney, Vadai, Pasta, Corn Flakes, Non Veg : Boiled Egg",
            lunch: "Roti, Dhal Makani, White Rice, White Pumpkin Moore kulambu, Rasam, Cup Curd, Raw Banana Fry, Papad",
            snacks: "Cake",
            dinner: "Phulka, Dhal, Fried Rice, White Rice, Sambar, Rasam, Loose Curd, Non Veg : Chicken Manchurian, Seasonal Fruit"
          },
          31: {
            breakfast: "Poha Namkeen, Onion Tomato Uthappam, Sambar, Peanut Chutney Non Veg : Scrambled Egg",
            lunch: "Phulka, Dhal tadka, Beet Root Poriyal, White Rice, Avarakkai sambar, Rasam, Cup Curd, Green Gram Sprouts, Fryums",
            snacks: "Veg Cutlet (2 Nos)",
            dinner: "Diamond Chapathi, Capsicum Paneer Masala, White Rice, Sambar, Rasam, Chow Chow Kootu, Curd rice, Musk melon"
          },


        }
        
        
      };

      const stringifiedMenus = JSON.stringify(fetchedMenus);
      localStorage.setItem('menus', stringifiedMenus);
      localStorage.setItem('storedDate', currDate);
      setMenus(fetchedMenus[selectedMenuType]);
    }
  }, [selectedMenuType]);

  const weekDays = [ 'Sunday',
    'Tuesday', 'Wednesday', 'Thursday','Friday', 'Saturday','Sunday','Monday',
    'Tuesday', 'Wednesday', 'Thursday','Friday', 'Saturday','Sunday','Monday',
    'Tuesday', 'Wednesday', 'Thursday','Friday', 'Saturday','Sunday','Monday',
    'Tuesday', 'Wednesday', 'Thursday','Friday', 'Saturday','Sunday','Monday',
    'Tuesday', 'Wednesday', 'Thursday','Friday', 'Saturday','Sunday','Monday',

  
  ];

  
const genZJokes = [
  "",
    "Aditi - I finally understand why my grades are like my socks: always mismatched.",
    "Dev - My phone battery lasts longer than my motivation to study.",
    "Riya - The only thing more predictable than my exam scores is my snack selection.",
    "Kartik - I'm just one coffee away from being a functioning adult. Or maybe two.",
    "Sanya - If procrastination were an Olympic sport, I’d have a gold medal.",
    "Raj - My room is so messy that even my thoughts get lost in there.",
    "Fatima - I can't decide what's worse: my sleep schedule or my bank balance.",
    "Arnav - College life: where every meal is an adventure and a gamble.",
    "Deepa - The hostel's Wi-Fi speed is a perfect reflection of my attention span.",
    "Nikhil - My college life can be summed up in two words: chaos and caffeine.",
    "Sneha - The only time I see my friends is during the free food giveaways.",
    "Akshay - I thought I was signing up for a degree, but it turns out I enrolled in a survival course.",
    "Sofia - My phone is smarter than me; it even knows when I’m trying to ignore my assignments.",
    "Rohit - I put the ‘pro’ in procrastination—just not in my grades.",
    "Tanya - The only thing I’m really good at is pretending to study.",
    "Samir - My GPA is just a reflection of my social life: very low.",
    "Maya - The hostel kitchen is a science experiment I’m not willing to participate in.",
    "Karan - My friends and I share everything—especially our struggles with adulting.",
    "Nisha - Exams are like blind dates; you never know how it's going to turn out.",
    "Vikash - The biggest mystery of college life? How I still have friends after all my bad cooking.",
    "Priyanka - I wish my grades were as high as my caffeine consumption.",
    "Siddharth - The best part of group projects? Realizing I’m not the only one who didn’t do the work.",
    "Neel - My study plan: sleep, snack, repeat.",
    "Anjali - The only thing heavier than my backpack is my existential dread.",
    "Kriti - I can’t adult today. Please don’t make me do it.",
    "Shiv - I thought the hardest part of college would be studying, but it’s really the food.",
    "Riya - My degree is in learning how to stress eat.",
    "Rahul - My roommate and I have a mutual understanding: we both don’t clean.",
    "Pooja - My plans for the future? More snacks and less studying."
  ];
  

  const handleMenuTypeSelect = (menuType) => {
    setSelectedMenuType(menuType);
    localStorage.setItem('selectedMenuType', menuType);
  };

  const getMenuForDay = (day) => {
    const menu = menus[day];
    if (!menu) {
      console.warn(`Menu not found for day ${day}`);
      return null;
    }
    return menu;
  };

  const [message, setMessage] = useState('');
  
  const handleMessageChange = (event) => {
      setMessage(event.target.value);
  };


  const [name, setName] = useState('');
  
  const handleNameChange = (event) => {
      setName(event.target.value);
  };

  const [typejoke, setTypejoke] = useState('');
  
  const handleJokeChange = (event) => {
      setTypejoke(event.target.value);
  };

  const riddleSubmissions = [
    '. - I am the guy in 6 bedroom who farts and puts blame'
    ,'Shreyans - If I could be any fictional character, Id choose Groot from Guardians of the Galaxy. Think about it: minimal dialogue responsibilities, so no stressful presentations or exams, just a consistent \`I am Groot.`\ And yet, somehow, Id still be the most loved character in the room. Plus, being a tree-like alien means Id never have to worry about running out of oxygen or Wi-Fi during long study sessions. Oh, and I can grow my own snacks—who wouldnt want that level of convenience?'
    ,'V - Loki, because I can rewrite my grade history…………'
    ,'anonymous  - kitni gaur sey dekha tha meri nazron ney ussey ki uske baad koi aur chehra khoobsurat hee na laga'
    ,'Brutal Bhes  - The V-ed up Sheep in The Boys OR Levi from AOT. Both are very Brutal.'
    ,'AJ - I wanna be Nobita, soo i could ask Doraemon for gadgets for CAT and FAT 🥹.'
    ,'Batman - Superman'
    ,'Raunak - Arthur Morgan because 1. he is cool, 2. he is cool, duh.'
    ,'babygotback - snorlax. already there personality wise. just need the looks.'
    ,'Dean Academics - To declare Saturday instructional.'
    ,'. - Minion Quite unlike Sigma choice, but that is funny, cute and adorable'
    ,'Cinderella - I am a guy but i would love it if aditya from q block 5xx brings me a glass heel and picks me up in his arms'
    ,'Rapunzel - I have a hair fetish'
    ,'Siddarth A  - I would like to be my dad'
    ,'Spiderman - So I couldve stopped the train and saved that guy'
    ,'Yajur - Ben 10. He is the best. There is nothing he can not do. '
    ,'Deadpool - To do the twerk dance'
    ,'Batman - To save Gotham from all the non-flushers'
    ];
  const dataRiddle = "Which fictional character would you like to be and why?";
  const dataRiddleNextWeek = "Which fictional character would you like to be and why?";
  const [riddle, setRiddle] = useState('');

  
  const handleRiddleChange = (event) => {
      setRiddle(event.target.value);
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    // Handle form submission, e.g., send data to backend or perform validation
    console.log('Message:', message);
    // You can add further logic here, like sending the review to a server
    // Reset form fields after submission if needed
    await sendMessageSubmitToTelegram(message);
    setMessage('');
  };
  
  const handleJoke = async (event) =>{
    event.preventDefault();
    console.log(name, typejoke);
    

    await sendJokeToTelegram(name, typejoke);
    window.alert("Your Joke has been sent! Please ensure the language is appropriate to increase the chances of it being shortlisted for others to see. 😊");

    localStorage.setItem('name', name);

    setName('');
    setTypejoke('');
  }

  const handleRiddle = async (event) =>{
    event.preventDefault();
    console.log(name, riddle);

    await sendJokeToTelegram("Riddle -"+dataRiddleNextWeek+" by- "+ name, riddle);
    window.alert("Your message has been sent! Please ensure the language is appropriate to increase the chances of it being shortlisted for others to see. 😊");

    localStorage.setItem('name', name);
    setName('');
    setRiddle('');
  }





  const [clickedTimes, setClickedTimes] = useState(0);


  const [emoji, setemoji] = useState(false);
  const emojisend = async (event) =>{
    console.log("laughing");
    setemoji(true);
    setLike(false);
    if(localStorage.getItem('name'))
      {
        setName(localStorage.getItem('name'));
      }

    if (clickedTimes < 2) {
      setClickedTimes(clickedTimes+1); // Increment clickedTimes
      await sendJokeToTelegram(name, "laughing");
    }

  }

  const [like, setLike] = useState(false);
  const likesend = async (event) =>{
    console.log("liked");
    setLike(true);
    setemoji(false);
    if(localStorage.getItem('name'))
      {
        setName(localStorage.getItem('name'));
      }

    if (clickedTimes < 2) {
      setClickedTimes(clickedTimes + 1); // Increment clickedTimes
      await sendJokeToTelegram(name, "liked");
    }


  }


  
  useEffect(() => {
    if(localStorage.getItem('name'))
      {
        setName(localStorage.getItem('name'));
      }
    sendMessageToTelegram();
  }, []);




  const currentTime = new Date().toLocaleString();
  const currentMonth = new Date().getMonth(); // January is 0, February is 1, ..., December is 11

  const sendMessageToTelegram = async (message) => {
    try {
      const response = await fetch('https://api.telegram.org/bot6270744341:AAFpOfrQj1RFEHKwx8qfo8W77oc7et0iTM0/sendMessage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          chat_id: '-1002035897228',
          text: `Ladies - ${currentTime}`
        })
      });

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error message:', error);
    }
  };

  const sendMessageSubmitToTelegram = async (message) => {
    try {
      const response = await fetch('https://api.telegram.org/bot6842910125:AAHtoikFcZgSLih4i7dfkDyQmYxO0IPM2s8/sendMessage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          chat_id: '-1002047632263',
          text: `Ladies - ${currentTime} Message -${message}`
        })
      });

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error message:', error);
    }
  };

  
  const sendJokeToTelegram = async (namee,typejokee) => {
    try {
      const response = await fetch('https://api.telegram.org/bot7132361049:AAFz9hWhsn64mQHP5DZWWQqERKrVAQY87YE/sendMessage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          chat_id: '-1002067896338',
          text: `(Ladies - ${currentTime}) - ${namee} - ${typejokee}`
        })
      });

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error message:', error);
    }
  };
  
  const reveal = () => {
    const reveals = document.querySelectorAll(".reveal");
    for (let i = 0; i < reveals.length; i++) {
      const windowHeight = window.innerHeight;
      const elementTop = reveals[i].getBoundingClientRect().top;
      const elementVisible = 100;

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  };

  


  const rotatee = () => {
    const rotatees = document.querySelectorAll(".rotatee");
    for (let i = 0; i < rotatees.length; i++) {
      const windowHeight = window.innerHeight;
      const elementTop = rotatees[i].getBoundingClientRect().top;
      const elementVisible = 100;

      if (elementTop < windowHeight - elementVisible) {
        rotatees[i].classList.add("active");
      } else {
        rotatees[i].classList.remove("active");
      }
    }
  };



  useEffect(() => {
    reveal();
    rotatee();

    window.addEventListener('scroll', () => {
      reveal();
      rotatee();
    });

    return () => window.removeEventListener('scroll', () => {});
  }, []);

    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      // Simulate animation trigger on component mount (like a refresh)
      setTimeout(() => setIsVisible(true), 100);
    }, []);

    const [slidefromUp, setslidefromUp] = useState(false);
  
    useEffect(() => {
      // Simulate animation trigger on component mount (like a refresh)
      setTimeout(() => setslidefromUp(true), 100);
    }, []);

    






    
    const [theme, setTheme] = useState('automatic');

    // Function to initialize theme based on local storage or device preference
    const initializeTheme = () => {
      const storedTheme = localStorage.getItem('theme');
      const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  
      if (storedTheme === 'dark' || storedTheme === 'light') {
        setTheme(storedTheme);
      } else {
        setTheme(prefersDarkMode ? 'dark' : 'light');
      }
    };
  
    useEffect(() => {
      initializeTheme(); // Initialize theme when component mounts
    }, []);
  
    const setAutomaticTheme = () => {
      const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const themeToSet = prefersDarkMode ? 'dark' : 'light';
      setTheme(themeToSet);
      localStorage.setItem('theme', 'automatic');
    };
  
    const setLightTheme = () => {
      setTheme('light');
      localStorage.setItem('theme', 'light');
    };
  
    const setDarkTheme = () => {
      setTheme('dark');
      localStorage.setItem('theme', 'dark');
    };




    const [showButtons, setShowButtons] = useState(false);

    const toggleButtons = () => {
      setShowButtons((prevShowButtons) => !prevShowButtons);
    };

    
 

    const [showMore, setShowMore] = useState(false);

    const toggleMore = () => {
      setShowMore((prevShowMore) => !prevShowMore);
    };

    const [toggleRiddle,setToggleRiddle] = useState(false);
    const toggleRiddleButton = () =>{
      setToggleRiddle((toggleRiddle)=> !toggleRiddle);
    }



    


  return (
    <div className='bg-slate-900 overflow-hidden'>
      <div className={`flex sm:p-5 justify-center ${theme === 'dark' ? '' : 'bg-slate-100 bg-opacity-100'}`}>
      
        <div className='sm:p-5 p-5 flex sm:w-2/3 w-full  flex-col justify-center'>
          <div className='flex-1 flex-col flex items-center'>
            <div className={`m-2 p-1 sm:w-2/3 w-full flex flex-row rounded-full   ${theme === 'dark' ? 'bg-purple-950' : 'bg-purple-100'} opacity-0 transition-all duration-300 ease-in-out ${slidefromUp ? 'opacity-100 -translate-y-0 p-1 sm:w-2/3' : '-translate-y-20 sm:pl-20 sm:pr-20 pt-50 pb-20 sm:w-1.5'} `}>
            <button 
              className={`flex w-1/3 justify-center font-bold transition-all p-3 m-2 rounded-full 
                ${selectedMenuType === "veg" 
                  ? theme === 'dark' 
                    ? 'text-slate-50 bg-green-700 hover:bg-green-600' 
                    : 'text-black bg-green-400 hover:bg-green-300'
                  : theme === 'dark' 
                    ? 'text-slate-50 hover:bg-purple-900 bg-purple-950' 
                    : 'text-black hover:bg-purple-200 bg-purple-100'
                }`} 
              onClick={() => handleMenuTypeSelect('veg')}
            > Veg
            </button>

            <button 
              className={`flex w-1/3 justify-center font-bold transition-all p-3 m-2 rounded-full 
                ${selectedMenuType === "special" 
                  ? theme === 'dark' 
                    ? 'text-slate-50 bg-purple-700 hover:bg-purple-600' 
                    : 'text-black  bg-purple-400 hover:bg-purple-300 '
                  : theme === 'dark' 
                  ? 'text-slate-50 hover:bg-purple-900 bg-purple-950' 
                  : 'text-black hover:bg-purple-200 bg-purple-100'
                }`} 
              onClick={() => handleMenuTypeSelect('special')}
            > Special
            </button>

            <button 
              className={`flex w-1/3 justify-center font-bold transition-all p-3 m-2 rounded-full 
                ${selectedMenuType === "nonVeg" 
                  ? theme === 'dark' 
                    ? 'text-slate-50 bg-red-800 hover:bg-red-600' 
                    : 'text-black  bg-red-400 hover:bg-red-300 '
                  : theme === 'dark' 
                  ? 'text-slate-50 hover:bg-purple-900 bg-purple-950' 
                  : 'text-black hover:bg-purple-200 bg-purple-100'
                }`} 
              onClick={() => handleMenuTypeSelect('nonVeg')}
            > Non-Veg
            </button>

          </div>

          <h2 className={`text-xl mt-3 font-bold ${theme === 'dark' ? 'text-white' : 'text-purple-600'}`}>
            {(( currentDay === today.getDate()) ? "( Today )" : (currentDay === (today.getDate() - 1) % 31) ? "( Yesterday )" : (currentDay === (today.getDate() + 1) % 31) ? "( Tomorrow )" : "")} 
          </h2>
          <h2 className={`text-3xl mt-3 font-extrabold ${theme === 'dark' ? 'text-gray-200' : ''}`}>
             October {currentDay} - {weekDays[currentDay]}
          </h2>

          <div className='flex w-full mt-2 justify-between '>
          <button className={` hover:underline p-2 m-2 rounded ${theme === 'dark' ? 'text-white' : ' text-black'}`} onClick={() => setCurrentDay((currentDay - 1 >= 1) ? currentDay - 1 : today.getDate())}>&lt;&lt; Previous Day</button>
          <button className={` hover:underline p-2 m-2 rounded ${theme === 'dark' ? ' text-white' : ' text-black'}`} onClick={() => setCurrentDay((currentDay + 1 <= 31) ? currentDay + 1 : today.getDate())}>Next Day &gt;&gt;</button>

          </div>
        </div>
          {currentMonth === 9 && getMenuForDay(currentDay) ? (
          <div>

            {Object.entries(getMenuForDay(currentDay)).map(([sectionName, menuItems]) => (
              <div className={`m-3 mt-7 p-4 rounded-lg  opacity-0 transition-all duration-500 ease-in-out 
              ${isVisible ? 'opacity-100 translate-y-0' : 'translate-y-20'}  
              ${theme === 'dark' ? 'bg-purple-800  border-purple-200 shadow-md border-b-4' : 'bg-purple-100 border-purple-500 shadow-md border-b-4'}
              ${(sectionName === "breakfast" && (currentDay === 4 || currentDay === 5 || currentDay === 11 || currentDay === 12 || currentDay === 18 || currentDay === 19 || currentDay === 25 || currentDay === 26) && ((currHour === 7 && currMin>=15)||(currHour>7)) && ((currHour === 9 && currMin<=30)||(currHour<9)) )
                  || (sectionName === "breakfast" && !(currentDay === 4 || currentDay === 5 || currentDay === 11 || currentDay === 12 || currentDay === 18 || currentDay === 19 || currentDay === 25 || currentDay === 26) && currHour >= 7 && currHour<9 )
                  || (sectionName === "lunch" && ((currHour === 12 && currMin>=30)||(currHour>12)) && ((currHour === 14 && currMin<=30)||(currHour<14)))
                  ||  (sectionName === "snacks" && ((currHour === 16 && currMin>=30)||(currHour>16)) && ((currHour === 18 && currMin<=30)||(currHour<18)))
                  ||   (sectionName === "dinner" && currHour >= 19 && currHour<21 )                  
                  ?
                (theme === 'dark' ? '  bg-purple-800 shadow-slate-600 shadow-xl ml-1 mr-1 pt-6 pb-6 border-purple-200 border-b-8 ' : ' bg-purple-100 ml-1 mr-1 pt-6 pb-6 border-purple-500 shadow-slate-400 shadow-lg border-b-8'): 
                ""}
              `} key={sectionName}>
                <h3 className={`font-bold ${theme === 'dark' ? 'text-purple-100' : 'text-black'}  `}>{sectionName.toUpperCase()}:</h3>
                <p className={` ${theme === 'dark' ? 'text-purple-100' : 'text-black'}  `}>{menuItems}</p>
                <br></br>
                <p className={`font-medium ${theme === 'dark' ? 'text-purple-100 opacity-75' : 'text-slate-600'}  text-xs `}>{(sectionName === "breakfast" && ( currentDay === 27 || currentDay === 28)) ? "7:15 AM - 9:30 AM" : (sectionName === "breakfast") ? "7:00 AM - 9:00 AM" : (sectionName === "lunch") ? "12:30 PM- 2:30 PM" : (sectionName === "snacks") ? "4:00 PM- 6:00 PM" : "7:00 PM - 9:00 PM"}</p>
              </div>
            ))}


          </div >
        ) : (
          <div className={` ${theme === 'dark' ? 'text-white' : 'text-black'}  `}>
            <p className='text-center'>Menu not available for this date. Please wait for one day so that we can fetch mess menu for you.</p>
          </div>
        )}



        <div className={` w-full mt-4 sm:w-full flex-col flex items-center`} onClick={toggleButtons}>
              <div className={`m-2  p-4 w-full flex flex-col items-center justify-center rounded-3xl   ${showButtons ? 'bg-opacity-100 shadow-md hover:bg-opacity-100' : ' bg-opacity-0 shadow-none hover:bg-opacity-70'}  
                    ${theme === 'dark' ? 'bg-gray-800' : 'bg-slate-200 hover:bg-slate-200 shadow-md'}  `}>
                <div className='flex flex-row items-center'>
                      <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className={`w-6   h-6 ${theme === 'dark' ? 'fill-slate-900 text-gray-400 ':'fill-white text-gray-600'} `}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      </svg>

                      <span className={`flex pl-2 text-lg   font-semibold ${theme === 'dark' ? 'text-gray-400':'text-gray-600'}`}>  Settings</span>
                </div>
                {showButtons && (
                  <>
                    <button 
                      className={`flex w-1/2 mt-8  justify-center font-bold transition-all p-3 m-2 rounded-full 
                        ${theme === 'light' ? 'text-white bg-purple-400 hover:bg-purple-500' : 'text-white bg-gray-800 hover:bg-gray-700'}
                      `}
                      onClick={setLightTheme}
                    >
                      Light
                    </button>

                    <button 
                      className={`flex w-1/2 justify-center font-bold transition-all p-3 m-2 rounded-full 
                        ${theme === 'dark' ? 'text-white bg-purple-500 hover:bg-purple-600' : 'text-black bg-gray-200 hover:bg-gray-300'}
                      `}
                      onClick={setDarkTheme}
                    >
                      Dark
                    </button>

                    <button 
                      className={`flex w-1/2 mt-10 justify-center font-bold transition-all p-3 m-2 rounded-full 
                        ${theme === 'light' ? 'text-white bg-gray-700 hover:bg-gray-700' : 'text-black bg-gray-200 hover:bg-gray-300'}
                      `}
                      onClick={setAutomaticTheme}
                    >
                      Device
                    </button>
                  </>
                )}
              </div>
            </div>
            <div className={` rotatee reveal  mt-4 w-full font-mono font-bold   shadow-lg  rounded-2xl ${theme === 'dark' ? ' bg-gradient-to-bl from-purple-300 shadow-purple-500 to-pink-300 text-black' : 'bg-gradient-to-bl shadow-purple-600 from-purple-700 to-pink-700 text-white'}`}>
              <div className='p-5'>
                <p className=' text-md font-bold opacity-50 text-center '>J o k e B o x</p>
                <p className=' text-4xl font-extrabold '>"</p>
                  {genZJokes[currDate]}
                <p className=' text-4xl text-right font-extrabold'>"</p>
                <div className={`flex flex-row items-center justify-center rounded-full w-fit p-2 ${theme === 'dark' ? 'bg-white bg-opacity-70': 'bg-white bg-opacity-90'}`}>
                  <button className={` rounded-full text-xl drop-shadow-md shadow-black transition-all    ${emoji === true? 'opacity-100 rounded-full scale-125':'opacity-60 '} `}  onClick={emojisend} alt ="emoji">😂</button>
                  <button className={` rounded-full text-xl drop-shadow-md shadow-black transition-all pl-4   ${like === true? 'opacity-100 rounded-full scale-125':'opacity-60 '} `}  onClick={likesend} alt ="like">❤️</button>
                  </div>
              </div>
            </div>


                  

          <div className={` reveal rotatee  mt-6 w-full font-mono font-bold   shadow-lg  rounded-2xl ${theme === 'dark' ? ' bg-gradient-to-bl from-slate-400 shadow-slate-500 to-slate-300 text-black' : 'bg-gradient-to-bl shadow-slate-400 from-slate-600 to-slate-500 text-white'}`}>
            <div className='p-3'>
              <p className=' text-md font-bold  opacity-50 text-center '> w e e k l y - t o p i c</p>
              <br></br>
              {dataRiddle}
              <br></br><br></br>
              {riddleSubmissions.map((riddles, index) => (
              <p key={index} className="bg-white p-2 mt-2 rounded-xl bg-opacity-30">
                {riddles}
              </p>
              ))}
                      <p className='mt-10 text-center'>NEXT WEEK TOPIC IS AVAILABLE BELOW 😋</p>

              <div className={`flex flex-row items-center justify-center  w-full rounded-lg  transition-all duration-300 ${theme ==='dark'?"text-black":"text-black"}  `}>
                
                <form onSubmit={handleRiddle} className={`p-4 mt-10  rounded-2xl hover:shadow-xl  bg-slate-100 flex-col items-center justify-center transition-all duration-300 ease-in-out ${toggleRiddle? "h-auto":"h-16"}  overflow-clip`}>
                <p onClick={toggleRiddleButton} className=' text-md font-extrabold  text-center text-lg'>SUBMIT FOR NEXT WEEK</p><br></br>

                  
                  {dataRiddleNextWeek}<br></br>
                  
                  <input
                        id="name"
                        rows="1"
                        onChange={handleNameChange}
                        value={name}
                        className={`w-full p-3 mt-2 placeholder:text-base text-base   bg-transparent border-b-2 border-slate-400 ${theme === 'dark' ? ' text-black' : 'text-black'}   placeholder:text-slate-400 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                        placeholder="Name"
                        required
                      />
                  <textarea
                        id="riddle"
                        rows="2"
                        onChange={handleRiddleChange}
                        value={riddle}
                        className={`w-full p-3 mt-2  placeholder:text-base text-base bg-transparent border-b-2 border-slate-400 ${theme === 'dark' ? ' text-black' : 'text-black'}   placeholder:text-slate-400 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                        placeholder="Type here. Best answers will be shown next week"
                        required
                      />
                    <button type="submit" className={`text-center mt-2 py-2.5 px-4 text-base sm:w-full w-full font-medium ${theme === 'dark' ? 'text-white bg-slate-800 hover:bg-slate-700' : 'text-white bg-slate-500 hover:bg-slate-600'}    rounded-2xl focus:ring-4 focus:ring-sky-200`}>
                      Send
                    </button>
                </form>
              </div>
            </div>
          </div>

            
              





            <div className={` w-full  mt-8 mb-8 m-0 sm:w-full flex-col flex items-center`} >
            <p className={`${theme === 'dark' ? 'text-slate-50' : 'text-black'} font-bold text-xl pb-4`}> Please give  suggestions/changes in mess you want in feedback. We will try to convey them to Hostel Office. 😊😊</p>

              <div className={` p-4 w-full flex flex-col  items-center justify-center rounded-3xl   ${showMore ? 'bg-opacity-100 shadow-md hover:bg-opacity-100' : ' bg-opacity-70 shadow-none hover:bg-opacity-100'}  
                    ${theme === 'dark' ? 'bg-gray-800' : 'bg-slate-200 hover:bg-slate-200 shadow-md'}  `}>
                
                <div className='flex w-full justify-center flex-row items-center' onClick={toggleMore}>
                  <span className={`flex pl-2 text-lg   font-semibold ${theme === 'dark' ? 'text-gray-400':'text-gray-600'}`}> Submit to JokeBox / Give Feedback </span>
                </div>
                {showMore && (
                  <>
                    <form onSubmit={handleJoke} className={`sm:w-2/3 w-full flex p-4 sm:m-2 mt-4 items-center justify-center ${theme === 'dark' ? '' : ' '} rounded-2xl border-spacing-4`}>
                      <div className="w-full rounded-lg ">

                        <div className={`px-2 py-2  ${theme === 'dark' ? '' : ' '} rounded-t-lg `}>
                        <p className={` text-xl text-center font-bold mb-4 ${theme === 'dark' ? 'text-white' : ''} `}>Submit to JokeBox</p>

                        <input
                          id="name"
                          rows="1"
                          onChange={handleNameChange}
                          value={name}
                          className={`w-full p-3  placeholder:text-base text-base bg-transparent border-slate-600 border-b-2  ${theme === 'dark' ? 'text-white' : 'text-black'}    placeholder:text-slate-500 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                          placeholder="Name"
                          required
                        />
                        <input
                          id="joke"
                          rows="1"
                          onChange={handleJokeChange}
                          value={typejoke}
                          className={`w-full p-3 placeholder:text-base text-base  bg-transparent border-slate-600 border-b-2   ${theme === 'dark' ? 'text-white' : 'text-black'}    placeholder:text-slate-500 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                          placeholder="Type and get quoted for a day of month."
                          required
                        />
                        </div>
                        <div className="flex items-end px-3 py-2 ">
                          <button type="submit" className={`text-center py-2.5 px-4 text-base sm:w-full w-full font-medium ${theme === 'dark' ? 'text-white bg-purple-900 hover:bg-purple-700' : 'text-white bg-purple-500 hover:bg-purple-600'}    rounded-2xl focus:ring-4 focus:ring-sky-200`}>
                            Send
                          </button>
                        </div>
                      </div>
                    </form>
                    <form onSubmit={handleSubmit} className={`sm:w-2/3 w-full flex p-4 sm:m-2 mt-4 items-center justify-center ${theme === 'dark' ? '' : ' '} rounded-2xl border-spacing-4`}>
                      <div className="w-full rounded-lg ">
                        <div className={`px-2 py-2  ${theme === 'dark' ? '' : ' '} rounded-t-lg `}>
                        <p className={` text-xl text-center font-bold mb-4 ${theme === 'dark' ? 'text-white' : ''} `}>Your valuable Feedback</p>

                        <textarea
                          id="message"
                          rows="5"
                          onChange={handleMessageChange}
                          value={message}
                          className={`w-full px-0 placeholder:text-sm text-base bg-transparent ${theme === 'dark' ? ' ' : ''} text-white border-b-2 border-slate-600  placeholder:text-slate-500 border-0 focus:ring-0 focus:outline-none active:ring-0`}
                          placeholder="Please share us your experience/suggestions. This app is live only because you use it. Your views are all that matters to us. Please also include ur contact to help us reach you. Type here...."
                          required
                        />
                        </div>
                        <div className="flex items-end px-3 py-2 ">
                          <button type="submit" className={`text-center py-2.5 px-4 text-base  w-full font-medium ${theme === 'dark' ? 'text-white bg-purple-900 hover:bg-purple-700' : 'text-white bg-purple-500 hover:bg-purple-600'}    rounded-2xl focus:ring-4 focus:ring-sky-200`}>
                            Send
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div> 
            </div>




            <div className='flex flex-row justify-between'>
              <div className={`mt-4 text-base text-left font-semibold ${theme === 'dark' ? 'text-white' : 'text-black'}`}> MESSTIME</div>
              <div className={`mt-4 text-base text-right font-semibold ${theme === 'dark' ? 'text-white' : 'text-black'}`}> - arc</div>
              </div>

              <div className={` w-full p-0  mt-10 reveal ${theme === 'dark' ? 'bg-purple-800 hover:bg-purple-700' : 'bg-purple-400 hover:bg-purple-500'}   transition-all duration-200 rounded-2xl`}>
              <button className={`m-0 p-10 rounded-lg text-3xl  ${theme === 'dark' ? 'text-white':'text-black'}  text-left transition-all`} >
                  <a href="https://drive.google.com/drive/folders/1CbQJwKgpRlPuQJtpb16Bn73QlXbSnLTA?usp=sharing">
                    How to make a homescreen shortcut of this app for iOS and android?
                    <p className=' text-base mt-3'>**If incase the menu for the day is worng please submit a Feedback to us to correct it **</p>
                  </a>
                  <p className='text-sm mt-4 hover:underline'>click here</p>
                </button>
              </div>
      </div>


      </div>

    </div>
    
    
  );
};


export default App;
